"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon.default;
  }
});

var _Icon = _interopRequireDefault(require("./Icon"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Icon/index.js
 ** module id = 695
 ** module chunks = 0
 **/